export class SubscriptionDto {
  email: string;
  constructor(email: string) {
    this.email = email;
  }
}
